<template>
  <div class="content-flex">
<!--    <div style="width:49%">-->
<!--      <div class="title-mark">-->
<!--        <span>货物类别运输金额排名统计</span>-->
<!--      </div>-->
<!--      <el-table-->
<!--        :data="amountRankingList"-->
<!--        size="mini"-->
<!--        style="width: 100%"-->
<!--        show-summary-->
<!--        :summary-method="getSummaries"-->
<!--      >-->
<!--        <el-table-column type="index" label="排名" width="50">-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="goodsCategory" label="货物类别">-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="volume" label="交易数量">-->

<!--        </el-table-column>-->
<!--        <el-table-column prop="amount" label="交易金额"> </el-table-column>-->
<!--      </el-table>-->
<!--    </div>-->
<!--    <div style="width:49%">-->
<!--      <div class="title-mark">-->
<!--        <span>货物类别运输数量排名统计</span>-->
<!--      </div>-->
<!--      <el-table-->
<!--        :data="quantityRankingList"-->
<!--        size="mini"-->
<!--        style="width: 100%"-->
<!--        show-summary-->
<!--        :summary-method="getSummaries"-->
<!--      >-->
<!--        <el-table-column type="index" label="排名" width="50">-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="goodsCategory" label="货物类别">-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="volume" label="交易数量"> </el-table-column>-->
<!--        <el-table-column prop="amount" label="交易金额"> </el-table-column>-->
<!--      </el-table>-->
<!--    </div>-->
    <div style="width:100%;margin-top:20px">
      <div class="title-mark">
        <span>平台注册用户展示</span>
      </div>
      <el-table :data="registeredUserList" size="mini" style="width: 100%">
        <el-table-column prop="customerRegisterNum" label="货主注册数量">
        </el-table-column>
        <el-table-column prop="tradeNum" label="交易数量"> </el-table-column>
        <el-table-column prop="tradeMoney" label="交易金额"> </el-table-column>
        <el-table-column prop="carriersRegisterNum" label="承运商注册数量">
        </el-table-column>
        <el-table-column prop="driverRegisterNum" label="司机注册数量">
        </el-table-column>
        <el-table-column prop="carRegisterNum" label="车辆注册数量">
        </el-table-column>
        <el-table-column prop="routeNum" label="运输线路数"> </el-table-column>
        <el-table-column prop="goodsTypeNum" label="货物品类数">
        </el-table-column>
      </el-table>
    </div>
    <div style="width:100%;margin-top:20px">
      <div class="title-mark">
        <span>运输线路排名</span>
      </div>
      <el-table :data="lineRankingList" size="mini" style="width: 100%">
        <el-table-column type="index" label="排名" width="50">
        </el-table-column>
        <el-table-column label="发货地">
          <el-table-column prop="deliveryProvince" label="省">
          </el-table-column>
          <el-table-column prop="deliveryCity" label="市"> </el-table-column>
        </el-table-column>
        <el-table-column label="到达地">
          <el-table-column prop="receiveProvince" label="省"> </el-table-column>
          <el-table-column prop="receiveCity" label="市"> </el-table-column>
        </el-table-column>
        <el-table-column prop="allTon" label="运输数量"> </el-table-column>
        <el-table-column prop="money" label="运输金额"> </el-table-column>
        <el-table-column prop="transportNum" label="参与运输车次">
        </el-table-column>
      </el-table>
    </div>
    <div style="width:100%;margin-top:20px">
      <div class="title-mark">
        <span>车找货信息</span>
      </div>
      <el-table :data="carSearchGoods.list" size="mini" style="width: 100%">
        <el-table-column prop="name" label="司机"> </el-table-column>
        <el-table-column prop="carNumber" label="车牌号"> </el-table-column>
        <el-table-column prop="startPositionLimit" label="所在城市">
        </el-table-column>
        <el-table-column prop="endPositionLimit" label="到达城市">
        </el-table-column>
        <el-table-column
          prop="publishTime"
          :formatter="formatDate"
          label="发布时间"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="carSearchGoods.pageSize"
        :total="carSearchGoods.total"
        @current-change="carChangePage"
        class="pagination"
        :hide-on-single-page="true"
      >
      </el-pagination>
    </div>
    <div style="width:100%;margin-top:20px">
      <div class="title-mark">
        <span>货找车信息</span>
      </div>
      <el-table :data="goodsSearchCar.list" size="mini" style="width: 100%">
        <el-table-column
          prop="publishTime"
          :formatter="formatDate"
          label="信息有效时间"
        >
        </el-table-column>
        <el-table-column prop="itemName" label="货物品名"> </el-table-column>
        <el-table-column prop="itemTon" label="货物总量"> </el-table-column>
        <el-table-column prop="startPosition" label="发货地址">
        </el-table-column>
        <el-table-column prop="endPosition" label="收货地址"> </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="goodsSearchCar.pageSize"
        :total="goodsSearchCar.total"
        @current-change="goodsChangePage"
        class="pagination"
        :hide-on-single-page="true"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import utils from "@/utils";
export default {
  components: {},
  data() {
    return {
      amountRankingList: [], //金额排名列表
      quantityRankingList: [], //数量排名列表
      registeredUserList: [], //注册用户列表
      lineRankingList: [], //运输线路排名列表
      //车找货信息
      carSearchGoods: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        list: []
      },
      //货找车信息
      goodsSearchCar: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        list: []
      }
    };
  },
  computed: {
    formatDate() {
      return utils.dateFormat;
    }
  },
  watch: {},
  methods: {
    init() {
      this.$http.platformFormCategoryOfGoods({ type: 3 }).then(res => {
        if (res.data.code == 200 && res.data.success) {
          this.amountRankingList = res.data.list;
        }
      });
      this.$http.platformFormCategoryOfGoods({ type: 4 }).then(res => {
        if (res.data.code == 200 && res.data.success) {
          this.quantityRankingList = res.data.list;
        }
      });
      this.$http.platformFormRegisterUserForm().then(res => {
        if (res.data.code == 200 && res.data.success) {
          this.registeredUserList = [res.data.data];
        }
      });
      this.$http.platformFormTransportRoute().then(res => {
        if (res.data.code == 200 && res.data.success) {
          this.lineRankingList = res.data.data;
        }
      });
    },
    //车找货
    getCarSearchGoodsList() {
      this.$http
        .platformFormEmptyCarList({
          pageNum: this.carSearchGoods.pageNum,
          pageSize: this.carSearchGoods.pageSize
        })
        .then(res => {
          if (res.data.code == 200 && res.data.success) {
            this.carSearchGoods.list = res.data.data.records;
            this.carSearchGoods.total = res.data.data.total;
          }
        });
    },
    //分页按钮
    carChangePage(e) {
      this.carSearchGoods.pageNum = e;
      this.getCarSearchGoodsList();
    },
    //货找车
    getGoodsSearchCarList() {
      this.$http
        .platformFormGoodsSearchCar({
          pageNum: this.goodsSearchCar.pageNum,
          pageSize: this.goodsSearchCar.pageSize
        })
        .then(res => {
          if (res.data.code == 200 && res.data.success) {
            this.goodsSearchCar.list = res.data.data.records;
            this.goodsSearchCar.total = res.data.data.total;
          }
        });
    },
    //分页按钮
    goodsChangePage(e) {
      this.goodsSearchCar.pageNum = e;
      this.getGoodsSearchCarList();
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });

      return sums;
    }
  },
  created() {},
  mounted() {
    this.init();
    this.getCarSearchGoodsList();
    this.getGoodsSearchCarList();
  }
};
</script>

<style lang="less" scoped>
.content-flex {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 1200px;
  border: 1px solid #eee;
  background: #fff;
  min-height: 600px;
  padding: 20px;
  box-sizing: border-box;
}
.title-mark {
  border-left: 3px solid #409eff;
  padding-left: 10px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}
.pagination {
  margin-top: 20px;
  float: right;
}
</style>
